export var AflaModuleStatus;
(function (AflaModuleStatus) {
    AflaModuleStatus["Overdue"] = "Overdue";
    AflaModuleStatus["Remaining"] = "5 days to go";
})(AflaModuleStatus || (AflaModuleStatus = {}));
